import { render, staticRenderFns } from "./PendingWarrants.vue?vue&type=template&id=0061e50d"
import script from "./PendingWarrants.vue?vue&type=script&lang=js"
export * from "./PendingWarrants.vue?vue&type=script&lang=js"
import style0 from "./PendingWarrants.vue?vue&type=style&index=0&id=0061e50d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports